export { default } from './SupportTab';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/SupportTab/index.ts